import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import electronUpdateSelector from './electronUpdateSelector';
import { showTooltip } from '../../../../../components/tooltips/tooltipActions';

import './ElectronAppUpdateNotify.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchShowTooltip: (tooltip) => dispatch(showTooltip({ tooltip })),
});

class ElectronAppUpdateNotify extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.updateReady && this.props.updateReady) {
            this.props.dispatchShowTooltip({
                selector: '.AccountUtil',
                position: 'bottom',
                distance: 10,
                text: 'A new version of Milanote is ready to install',
            });
        }
    }

    render() {
        const { updateReady } = this.props;

        if (!updateReady) return null;

        return (
            <div className="ElectronAppUpdateNotify">
                <div className="pulse" />
            </div>
        );
    }
}

ElectronAppUpdateNotify.propTypes = {
    updateReady: PropTypes.bool,
    dispatchShowTooltip: PropTypes.func,
};

export default connect(electronUpdateSelector, mapDispatchToProps)(ElectronAppUpdateNotify);
